import React from 'react';

import {
  StyledClearFieldButton,
  StyledPill,
  StyledPillClose,
  StyledPillsRow,
  StyledSrOnly,
} from './styles';
import { FilterPillsProps } from './types';

export const FilterPills = ({
  values,
  getLabelForValue,
  onRemove,
  onClear,
  labelledById,
  srOnlyId,
  srOnlyLabel,
  clearLabel,
}: FilterPillsProps): React.ReactElement | null => {
  if (values.length === 0) return null;

  return (
    <StyledPillsRow aria-labelledby={`${labelledById} ${srOnlyId}`}>
      <StyledSrOnly id={srOnlyId}>{srOnlyLabel}</StyledSrOnly>
      {values.map((v) => (
        <StyledPill key={v} type="button" onClick={() => onRemove(v)} aria-label={`Remove filter: ${getLabelForValue ? getLabelForValue(v) : v}`}>
          {getLabelForValue ? getLabelForValue(v) : v}
          <StyledPillClose aria-hidden="true">&times;</StyledPillClose>
        </StyledPill>
      ))}
      <StyledClearFieldButton type="button" onClick={onClear}>
        {clearLabel}
      </StyledClearFieldButton>
    </StyledPillsRow>
  );
};
